export const Types = {
    TICKET_LIST: "TICKET_LIST",
    GET_ATTACHMENT:"GET_ATTACHMENT",
    ATTACHMENT_NOT_FOUND:"ATTACHMENT_NOT_FOUND"
  };